import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { ITaiKhoan } from 'src/types/TaiKhoan.type';

const taiKhoanSlice = createSlice<ITaiKhoan | null, SliceCaseReducers<ITaiKhoan | null>>({
  name: 'TaiKhoan',
  initialState: null,
  reducers: {
    setTaiKhoan: (state, { payload }: PayloadAction<ITaiKhoan | null>) => {
      return payload;
    },
  },
});

export const { setTaiKhoan } = taiKhoanSlice.actions;

export default taiKhoanSlice.reducer;
